var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { convertToCSSValue, getGeometryStyle, getHeightWidth } from '../../helpers/styles';
import { getMarginBottom, getMarginLeft, getMarginRight, getMarginTop, getMaxHeightWidth, getMinHeightWidth, StyledHermesysButtonContent } from '../Button';
var StyledLabelWithBorders = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n  margin: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  color: ", ";\n  border: ", ";\n  background: ", ";\n  outline: ", ";\n  box-sizing: ", ";\n  border-radius: ", ";\n  cursor: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  border-left-color: ", ";\n  border-top-color: ", ";\n  border-right-color: ", ";\n  border-bottom-color: ", ";\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  ", "\n  ",
    "\n  ", "\n  ", "\n  margin: ",
    ";\n  ",
    "\n  ",
    "\n  ",
    "\n  ",
    "\n  color: ",
    ";\n  border: ", ";\n  background: ", ";\n  outline: ", ";\n  box-sizing: ", ";\n  border-radius: ", ";\n  cursor: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  border-left-color: ",
    ";\n  border-top-color: ", ";\n  border-right-color: ",
    ";\n  border-bottom-color: ",
    ";\n  background-color: ",
    ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), function (_a) {
    var geometry = _a.geometry;
    return getGeometryStyle(geometry);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return getHeightWidth(windowTheme.button.width, windowTheme.button.height);
}, function (_a) {
    var minimumSize = _a.minimumSize;
    return minimumSize && getMinHeightWidth(minimumSize);
}, function (_a) {
    var maximumSize = _a.maximumSize;
    return maximumSize && getMaxHeightWidth(maximumSize);
}, function (_a) {
    var windowTheme = _a.windowTheme, attributes = _a.attributes;
    return attributes.hasOwnProperty('margin')
        ? convertToCSSValue(attributes.margin)
        : windowTheme.button.margin;
}, function (_a) {
    var attributes = _a.attributes;
    return attributes.marginLeft && getMarginLeft(attributes.marginLeft);
}, function (_a) {
    var attributes = _a.attributes;
    return attributes.marginRight && getMarginRight(attributes.marginRight);
}, function (_a) {
    var attributes = _a.attributes;
    return attributes.marginTop && getMarginTop(attributes.marginTop);
}, function (_a) {
    var attributes = _a.attributes;
    return attributes.marginBottom && getMarginBottom(attributes.marginBottom);
}, function (_a) {
    var windowTheme = _a.windowTheme, fontColor = _a.fontColor;
    return fontColor !== null && fontColor !== void 0 ? fontColor : windowTheme.button.color;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.border;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.background;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.outline;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.boxSizing;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.borderRadius;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.cursor;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.fontFamily;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    var _b;
    return (_b = windowTheme.label) === null || _b === void 0 ? void 0 : _b.fontSize;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    var _b;
    return (_b = windowTheme.label) === null || _b === void 0 ? void 0 : _b.fontWeight;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.borderColor.left;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.borderColor.top;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.borderColor.right;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.borderColor.bottom;
}, function (_a) {
    var windowTheme = _a.windowTheme, backgroundColor = _a.backgroundColor;
    return backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : windowTheme.button.backgroundColor;
});
var StyledDiv = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 15px;\n  height: 10px;\n  position: absolute;\n  border: 1px solid white;\n  background-color: ", ";\n  left: ", ";\n  font-size: 8px;\n  border-radius: 3px;\n  color: black;\n"], ["\n  width: 15px;\n  height: 10px;\n  position: absolute;\n  border: 1px solid white;\n  background-color: ",
    ";\n  left: ", ";\n  font-size: 8px;\n  border-radius: 3px;\n  color: black;\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor, windowTheme = _a.windowTheme;
    return backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : windowTheme.button.backgroundColor;
}, function (_a) {
    var left = _a.left;
    return convertToCSSValue(left);
});
var LabelWithBorders = function (props) {
    var windowId = props.windowId, attributes = props.attributes, identifier = props.identifier, type = props.type, system = props.system, className = props.className, restProps = __rest(props, ["windowId", "attributes", "identifier", "type", "system", "className"]), text = attributes.text, geometry = attributes.geometry, minimumSize = attributes.minimumSize, maximumSize = attributes.maximumSize, backgroundColor = attributes.backgroundColor, fontColor = attributes.fontColor, leftLabel = attributes.leftLabel, rightLabel = attributes.rightLabel, leftLabelText = attributes.leftLabelText, rightLabelText = attributes.rightLabelText;
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledLabelWithBorders, __assign({ id: identifier, "data-widget-type": type, geometry: geometry }, restProps, { minimumSize: minimumSize, maximumSize: maximumSize, attributes: attributes, fontColor: fontColor, backgroundColor: backgroundColor }),
            leftLabel && (React.createElement(StyledDiv, { backgroundColor: backgroundColor, left: leftLabel, windowTheme: restProps.windowTheme }, leftLabelText)),
            React.createElement(StyledHermesysButtonContent, null, text),
            rightLabel && (React.createElement(StyledDiv, { backgroundColor: backgroundColor, left: rightLabel, windowTheme: restProps.windowTheme }, rightLabelText)))));
};
export default LabelWithBorders;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map